import React from 'react';
import { Field } from 'formik';
import { Form as BulmaForm } from '@codeparva/ui-components-library';
import { FormFieldsTypes } from './FormFieldsTypes';
import { getAsterisk } from './helper/GetAstrisk';
export const CheckBoxField = ({
  name,
  label,
  required,
}: FormFieldsTypes.ICheckBoxField) => {
  const { CheckBox } = BulmaForm;
  return (
    <>
      {label && (
        <label htmlFor={name}>
          {label}
          {required === true && getAsterisk()}
        </label>
      )}
      <Field type="checkbox" name={name} id={name} as={CheckBox}>
        <a href="#">I agree to the terms and conditions</a>
      </Field>
    </>
  );
};
